import React, { useEffect } from "react"
import LoginHeader from "../component/login/LoginHeader"
import LoginForm from "../component/login/LoginForm"
import LoginNotice from "../component/login/LoginNotice"
import Avatar from "@material-ui/core/Avatar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import LoginImage from "../component/login/LoginImage";
import { getNotice } from "../api/helpline/notice"
import { getAuth } from "../api/helpline/account"
import { EditorState, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'; //wysiwygエディタを整列するために必要なCSS
import '../static/css/react-draft-wysiwyg.css'; //wysiwygエディタのレイアウトを調整するカスタムCSS

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    minHeight: "100vh",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexGrow: 1,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));


interface Prop {
  form: {
    userId: string
    password: string
  },
  handleChangeForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined; }>) => void
  logIn: (token: string, role: string, ssflg: string) => void,
  handleError: (err: any) => void,
  notification: Notification,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleNotificationClose: (event?: React.SyntheticEvent<Element, Event> | undefined, reason?: string | undefined) => void,
}
interface Notification {
  open: boolean,
  level: "success" | "info" | "warning" | "error" | undefined,
  message: string,
}


const Login: React.FC<Prop> = (props) => {
  const classes = useStyles();
  //2 お知らせ情報をNoticeコンポーネントに渡す(未ログイン)
  const [errorMsg, setErrorMsg] = React.useState('')
  const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty());
  const { form, logIn, handleError, notification, handleNotificationClose, handleChangeForm, handleNotificationOpen } = props
  //初期表示APIコール
  useEffect(() => {
    let cleanedup = false
    getNotice().then(res => {
      if (!cleanedup && (res.indexOf('{\"blocks\":[{') !== -1)) {
        setEditorState(() => EditorState.createWithContent(convertFromRaw(JSON.parse(res))));
      }
    }).catch(err => handleError(err))
    return () => { cleanedup = true }
  }, [])
  //ユーザー認証サービス呼び出し
  const onSubmit = async (event: any) => {
    event.preventDefault();
    const results = await getAuth(form.userId, form.password).catch(err => err)
    if (results.token && results.roles[0] && results.ssFlg) {
      const role = results.roles.map((value: { role: string; }) => value.role).join()
      setErrorMsg('')
      logIn(results.token, role, results.ssFlg)
    } else if (results.error) {// return Response obj
      setErrorMsg(results.error.message)
    } else {// return Error obj
      handleError(results)
    }
  }


  return (
    <React.Fragment>
      <LoginHeader
        notification={notification}
        handleNotificationClose={handleNotificationClose}
      />
      <Grid container className={classes.root}>
        <CssBaseline />
        <Grid item xs={12} sm={12} md={5} component={Paper} elevation={0} square>
          <div className={classes.paper} >
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Login
            </Typography>
            <LoginForm form={form} handleChangeForm={handleChangeForm} errorMsg={errorMsg} onSubmit={onSubmit} handleError={handleError} handleNotificationOpen={handleNotificationOpen} />{/**ログインフォーム */}
            <Grid container>
              <Grid item xs>
                <LoginNotice editorState={editorState} />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <LoginImage />{/**ログイン画面右側の画像 */}
      </Grid>
    </React.Fragment>
  )
}

export default Login